import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['form']

    connect() {
    }

    toggleOtherField(event) {
        if (event.target.dataset.otherSelectImplemented !== undefined)
            if (event.target.value === "Other") {
                // this.addOtherInput(event)
            } else {
                let id = event.target.dataset.id
                let otherFieldInput = this.parentDiv(event).querySelector(`[data-other-input-id="${id}"]`)
                if (otherFieldInput)
                    otherFieldInput.remove()
            }
    }

    addOtherInput(event) {
        let input = document.createElement("input")
        input.type = "text"
        input.name = event.target.name
        input.value = event.target.dataset.otherSelectCurrentValue
        input.dataset.otherInputId = event.target.dataset.id
        input.dataset.action = "change->other-select#submit"
        input.classList = event.target.dataset.otherSelectInputClass
        input.required = true
        this.parentDiv(event).appendChild(input)
    }

    parentDiv(event) {
        let id = event.target.dataset.id;
        return event.target.closest('form').querySelector(`[data-parent-id="${id}"]`)
    }

    submit(event) {
        console.log('other select submit init')
        event.preventDefault();
        this.toggleOtherField(event)
        event.target.form.requestSubmit()
        console.log('other select submit completed')
    }

    sendRequest(event) {
        let token = document.querySelector('meta[name="csrf-token"]').content
        let url = event.target.dataset.url
        let fieldName = event.target.value
        let scopeName = event.target.dataset.scopeName
        fetch(url, {
            method: "PATCH",
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json",
                "Accept": "text/vnd.turbo-stream.html"
            },
            body: JSON.stringify({
                [scopeName]: {
                    field: fieldName

                },
            }),
        })
            .then((response) => response.text())
            .then((html) => {
                Turbo.renderStreamMessage(html)
            })

    }
}
